'use client'
import AirDatepicker from "air-datepicker";
import "air-datepicker/air-datepicker.css";
import { computedClass } from 'utils'
import { forwardRef, useEffect, useRef, useState } from 'react'
import './style.scss'

const sanitizeProps = (props) => {
	const map = ['className', 'type','disabled', 'placeholder', 'name', 'onChange', 'onBlur','defaultValue', 'value', 'onInput', 'required', 'readonly']
	return Object.entries(props).reduce((acc,[prop,value])=>{
		if(map.map(x=>x.toLowerCase()).includes(prop.toLowerCase())){
			acc[prop] = value
		}
		return acc
	}, {})
}

const FieldInput = ({onFocus,onBlur,error,date,setValue, register, ref = () => {}, ...props }) => {
   


	 if(date){
		props.readOnly = true;
	 }

	 const inputRef = useRef();
    const { type, maxlength, className = '' } = props
    const [textareaCount, setTextareaCount] = useState(0)

    const onTextareaInput = ({ target: { value } }) => {
        setTextareaCount(value.length)
    }

	
    const classes = computedClass({
        'field-input':true,
        'field-input--error':error
    })

	 useEffect(() => {
		if (inputRef.current && date)
		  new AirDatepicker(inputRef.current, {
			 position: "top center",
			 autoClose: true,
			 selectedDates: [],
			 onSelect: ({ formattedDate }) => {
				setValue(props.name, formattedDate, { shouldValidate: true })
			 },
			//  maxDate: new Date(),
		  });
	 }, [inputRef]);

  

    if (type == 'textarea') {
        return (
            <>
                <textarea {...props} ref={ref} onBlur={onBlur} onFocus={onFocus} onInput={onTextareaInput} className={`field-input`} />
                <div className="field-input-block__count">
                    {textareaCount} / {maxlength}
                </div>
            </>
        )
    }

    return <input  {...sanitizeProps(props)} ref={(rf) => {ref(rf); inputRef.current = rf}} onBlur={onBlur} onFocus={onFocus}  className={`${classes} ${className}`} />
}

export default FieldInput
